module.exports = __webpack_public_path__ + "static/media/mood_happy_dark.06eaa258.png";